import { ActionStore } from "./action-store";
import { AdminStore } from "./admin-store";
import { AppStore } from "./app-store";
import { AuditStore } from "./audit-store";
import { AuthStore } from "./auth-store";
import { ProjectAppStore } from "./project-app-store";
import { ProjectMemberStore } from "./project-member-store";
import { ProjectPermissionStore } from "./project-permission-store";
import { ProjectStore } from "./project-store";
import { ReleaseNoteStore } from "./releasenote-store";
import { SystemMessageStore } from "./system-message-store";
import { UIStore } from "./ui-store";
import { UserStore } from "./user-store";

// tslint:disable-next-line:variable-name
export module RootStore{
	export const appStore = new AppStore();
	export const authStore = new AuthStore();
	export const uiStore = new UIStore();
	export const projectStore = new ProjectStore();
	export const auditStore = new AuditStore();
	export const userStore = new UserStore();
	export const actionStore = new ActionStore();
	export const projectMemberStore = new ProjectMemberStore();
	export const projectPermissionStore = new ProjectPermissionStore();
	export const projectAppStore = new ProjectAppStore();
	export const releaseNoteStore = new ReleaseNoteStore();
	export const adminStore = new AdminStore();
	export const systemMessageStore = new SystemMessageStore();
}



// WEBPACK FOOTER //
// ./src/stores/root-store.ts